/// <reference path="../../app.ts" />
/// <reference path="../subcataccordion.ts" />
/// <reference path="../isubcataccordion.ts" />
module Cfnc
{
    "use strict";

    export class FinancialAid extends SubCatAccordion implements IsubCatAccordion
    {
        toolTipHeader: string = "Which financial aid programs/opportunities interest you?";

        typeCbs = [{ type: "Academic Scholarships", isChecked: false },
            { type: "Athletic Scholarships", isChecked: false },
            { type: "Federal Work Study", isChecked: false },
            { type: "Federal/State Grants", isChecked: false },
            { type: "Institutional Grants", isChecked: false },
            { type: "Parent Loans", isChecked: false }];

        public getSelectedTypes(): Array<string>
        {
            var selectedTypes = new Array<string>();
            this.selected = false;
            for ( var i in this.typeCbs )
            {
                if ( this.typeCbs[i].isChecked )
                {
                    selectedTypes.push( this.typeCbs[i].type );
                    this.selected = true;
                }
            }
            return selectedTypes;
        }
    }
}